import React, { useState, useEffect, useRef, useCallback } from 'react';

const playNotificationSound = (() => {
  let audioCtx = null;
  return () => {
    try {
      if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();
      osc.connect(gain);
      gain.connect(audioCtx.destination);
      osc.frequency.setValueAtTime(880, audioCtx.currentTime);
      osc.frequency.exponentialRampToValueAtTime(660, audioCtx.currentTime + 0.15);
      gain.gain.setValueAtTime(0.15, audioCtx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.3);
      osc.start(audioCtx.currentTime);
      osc.stop(audioCtx.currentTime + 0.3);
    } catch (e) {
    }
  };
})();

const DashboardCard = ({ config, value, notification, label }) => {
  const [showNotif, setShowNotif] = useState(false);
  const [highlight, setHighlight] = useState(false);
  const [displayValue, setDisplayValue] = useState(value);
  const [notifMessage, setNotifMessage] = useState('');
  const changeKeyRef = useRef(null);

  const animateValue = useCallback((from, to) => {
    const steps = 20;
    const diff = to - from;
    const stepSize = diff / steps;
    const duration = 500;
    const intervalMs = duration / steps;
    let step = 0;

    setDisplayValue(from);
    const anim = setInterval(() => {
      step++;
      if (step >= steps) {
        setDisplayValue(to);
        clearInterval(anim);
      } else {
        setDisplayValue(Math.round(from + stepSize * step));
      }
    }, intervalMs);
    return () => clearInterval(anim);
  }, []);

  useEffect(() => {
    if (notification && notification.changeKey !== changeKeyRef.current) {
      changeKeyRef.current = notification.changeKey;
      setNotifMessage(notification.message);
      setShowNotif(true);
      setHighlight(true);
      playNotificationSound();

      const cleanupAnim = animateValue(notification.previous, notification.current);

      const dismissTimer = setTimeout(() => setShowNotif(false), 7000);
      const highlightTimer = setTimeout(() => setHighlight(false), 5000);

      return () => {
        cleanupAnim();
        clearTimeout(dismissTimer);
        clearTimeout(highlightTimer);
      };
    } else if (!notification) {
      setDisplayValue(value);
    }
  }, [notification, value, animateValue]);

  useEffect(() => {
    if (!notification) setDisplayValue(value);
  }, [value, notification]);

  return (
    <div
      className={`stat-card ${highlight ? 'stat-card--highlighted' : ''}`}
      style={{ borderLeftColor: config.color }}
    >
      <div className="stat-card-body">
        <div className="stat-icon" style={{ backgroundColor: config.bg, color: config.color }}>
          <i className={config.icon}></i>
        </div>
        <div className="stat-info">
          <h3 className={`stat-value ${highlight ? 'stat-value--bounce' : ''}`}>
            {displayValue}
          </h3>
          <span className="stat-label">{label}</span>
          <div className={`stat-notification ${showNotif ? 'stat-notification--visible' : ''}`}>
            {notifMessage}
          </div>
        </div>
        {highlight && <span className="stat-badge">UPDATED</span>}
      </div>
    </div>
  );
};

export default DashboardCard;